"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import Icon from "@/assets/images/circle-arrow-up-right.png";
import { allCategoryList } from "@/components/CategoryDetails/arrayCategorylist";
import DynamicImage from "../DynamicImages/DynamicImage";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";
import { useDispatch } from "react-redux";
import Image from "next/image";

const Card = ({ src, text }) => {
  return (
    <div className=" mx-[4px] relative flex flex-col justify-between smd:justify-end h-[332px] rounded-10 overflow-hidden categoryText group">
      <Image
        src={src}
        fill
        className="object-cover !transition-transform customDuration-800 !transform group-hover:scale-110"
        alt="bg"
      />
      <div className=" px-[25px] py-[20px] flex justify-end smd:hidden">
        <Image
          src={Icon}
          width={27}
          height={27}
          className=" object-contain z-[1]"
          alt="icon-img"
        />
      </div>
      
      <div className="relative px-[22px] py-[18px]">
        <p className=" animated-border  text-[14px] text-white  inline-block relative ">
          {text}
        </p>
      </div>
    </div>
  );
};

const ExploreAllLuxuryBrands = ({ categoryType }) => {
  const DataResponse = allCategoryList.find((item) => item[categoryType])?.[
    categoryType
  ];
  const collectionListData = Array.isArray(DataResponse?.collectionList)
    ? DataResponse.collectionList
    : [];

  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    const updateCount = () => {
      setCount(api.scrollSnapList().length);
      setCurrent(api.selectedScrollSnap() + 1);
    };

    updateCount();

    api.on("reInit", updateCount);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });

    return () => {
      api.off("reInit", updateCount);
      api.off("select");
    };
  }, [api]);

  // Function to go to a specific slide when clicking a dot
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };

  const dispatch = useDispatch();
  const updateBreadcrumb = (category) => {
    dispatch(AddNewBreadcrum(category));
  };

  return (
    <div className="">
      {/* <div className="flex justify-center mb-[28px]">
          <Link
            href="/brands?type=luxury"
            className=" inline-flex text-[13px] py-[7px] px-[20px] rounded-full  bg-transparent text-[#0c2340] opacity-99 border border-[#0c2340] transition-all ease-in-out duration-500 hover:opacity-100 hover:bg-[#0c2340] hover:text-white hover:transition-all hover:ease-in-out hover:duration-500"
          >
           Browse All Luxury Brands
          </Link>
        </div> */}
      {/* <div className=" flex justify-between gap-3 pb-7  items-center lg:pb-3">
        <h2 className="  text-[25px] text-black font-semibold  leading-[26px] lg:text-[20px] lg:leading-[26px] lg:text-blue1 lg:mb-0 ">
          Explore Luxury Appliance Brands
        </h2>
        <Link
          href="/luxury-appliances"
          className=" inline-flex items-center whitespace-nowrap min-h-[44px] font-semibold bg-[#0B223C] border text-white rounded-[30px] px-5 py-[7px] sm:min-h-[33px] sm:text-[12px]"
        >
          Explore All
        </Link>
      </div> */}
      <Carousel
        opts={{ align: "start" }}
        className="w-full pb-[48px] lg:pb-6 "
        setApi={setApi}
      >
        <CarouselContent className="m-0">
          {collectionListData.map((collection, index) => (
            <CarouselItem
              key={index}
              className="basis-1/5 m-0 mlg:basis-1/4 slg:basis-2/6 smd:basis-2/5 viewedCard570:basis-2/4 mob:basis-3/4"
            >
              <Link
                href={collection?.link}
                onClick={() =>
                  updateBreadcrumb([
                    { name: "Luxury Appliances", url: "/luxury-appliances" },
                    { name: collection?.title, url: collection?.link },
                  ])
                }
              >
                <Card text={collection?.title} src={collection?.img} />
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        {api?.scrollSnapList()?.length > 1 && (
          <div className=" grid grid-cols-[1fr_auto] items-center gap-3 pl-[20px] ">
            {/* Clickable Pagination Dots */}
            <div className="flex justify-center ">
              {Array.from({ length: count }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-full h-1  transition-all ${
                    current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
                  }`}
                />
              ))}
            </div>
            {/* Navigation Buttons */}
            <div className="flex items-center justify-end gap-3">
              <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
              <div className="text-sm text-[#0C2340] font-medium">
                {current}/{count}
              </div>
              <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
            </div>
          </div>
        )}
      </Carousel>
    </div>
  );
};

export default ExploreAllLuxuryBrands;
